/* eslint-disable react-hooks/exhaustive-deps */
import CustomButton from "components/CustomButton/CustomButton";
import DialogAlertAction from "components/DialogAlertAction/DialogAlertAction";
import PenalizeForm from "./PenalizeForm";
import usePenalizeForm from "./utils/hooks/usePenalizeForm";

const DialogPenalizeForm = ({
    data, penalizedStudents: {
        dialogs: { dialogPenalizeForm },
        currentPenalty, penalizeStudentFromReservationList
    },
}) => {
    const form = usePenalizeForm({
        currentPenalty, dialogPenalizeForm
    });
    const { renderData } = form;
    return (
        <DialogAlertAction 
            show={dialogPenalizeForm.value}
            toggleShow={dialogPenalizeForm.toggle}
            variant="secondary"
            title={renderData.title}
            contentComponent={
                <PenalizeForm 
                    subtitle={renderData.subtitle}
                    form={form} 
                    data={data}
                    isUpdate={currentPenalty !== null}/>}
            widthContent="100%"
            minWidth="650px"
            spacingContainer="10px">
            <CustomButton 
                text={renderData.confirm}
                width="130px"
                onClick={() => penalizeStudentFromReservationList(form.value)}
                disabled={!form.isCompleted() || !form.areThereChangesWhenIsUpdate()}/>
            <CustomButton 
                text="No, cancelar"
                width="130px"
                variant="secondary"
                onClick={dialogPenalizeForm.hide}/>
        </DialogAlertAction>
    );
}

export default DialogPenalizeForm;